<div class="container">

    <div class="row" style="margin: 0 30px;">
        <div class="col">
            <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E&#34;); margin-bottom: 30px;" aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a routerLink="/ad-accounts">Ad Accounts</a></li>
                    <li class="breadcrumb-item"><a routerLink="/ad-accounts/{{ accountId }}">{{ accountId | titlecase }}</a></li>
                    <li class="breadcrumb-item"><a routerLink="/ad-accounts/creative-assistant/{{ accountId }}">Creative Analysis Assistant</a></li>
                    <li class="breadcrumb-item active" aria-current="page">List Creatives</li>
                </ol>
            </nav>

            <div class="row">
                <div class="col">
                    <h1>Images <span *ngIf="!loadingImages">[{{ images.length }}]</span></h1>
                </div>
                <div class="col-auto">
                    <a *ngIf="export['img'].url" [href]="export['img'].url" target="_blank" style="margin-right: 20px;">Open GS Export</a>
                    <button *ngIf="!export['img'].loading" type="button" class="btn btn-dark" (click)="exportToGS('img')">
                        <i class="bi bi-file-earmark-spreadsheet"></i> Export
                    </button>
                    <span *ngIf="export['img'].loading" class="spinner-border text-dark" role="status" aria-hidden="true"></span>
                </div>
            </div>            
            <div style="width: 73vw !important; overflow-x: scroll;">
                <table class="table table-sm table-condensed table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">URL</th>
                            <th scope="col">Main Angle</th>
                            <th scope="col">Creative Style</th>
                            <th scope="col">Creative Format</th>
                            <th scope="col">Target Market</th>
                            <th scope="col">Market Awareness</th>
                            <th scope="col">Discounts</th>
                            <th scope="col">Headline</th>
                            <th scope="col">Person Feature</th>
                            <th scope="col">Call To Action</th>
                            <th scope="col">QA</th>
                            <th scope="col">Review</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="images.length > 0">
                        <tr *ngFor="let creative of images">
                            <td><a routerLink="/ad-accounts/creative-assistant/{{ accountId }}/{{ creative.id }}">{{ creative.id }}</a></td>
                            <td><a href="{{ creative.url }}" target="_blank" [ngbTooltip]="creative.url"><img src="{{ creative.url }}" alt="{{ creative.id }}" style="max-width: 40px; max-height: 40px; border-radius: 3px;"></a></td>                        
                            <td>{{ creative.mainAngle }}</td>                        
                            <td>{{ creative.creativeStyle }}</td>                        
                            <td>{{ creative.creativeFormat }}</td>                        
                            <td>{{ creative.targetMarket }}</td>                        
                            <td>{{ creative.marketAwareness }}</td>                        
                            <td>{{ creative.discounts }}</td>                        
                            <td>{{ creative.headline }}</td>                        
                            <td>{{ creative.personFeature }}</td>                        
                            <td>{{ creative.callToAction }}</td>                        
                            <td>{{ creative.needsQa ? '❌' : '-' }}</td>                        
                            <td><span [ngbTooltip]="creative.needsExpertReviewReason">{{ creative.needsExpertReview ? '❌' : '-' }}</span></td>                        
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="loadingImages" style="text-align: center;">
                    <span class="spinner-border text-dark" role="status" aria-hidden="true"></span>
                </div>
            </div>

            <div class="row" style="margin-top: 50px;">
                <div class="col">
                    <h1>Videos <span *ngIf="!loadingVideos">[{{ videos.length }}]</span></h1>
                </div>
                <div class="col-auto">
                    <a *ngIf="export['vid'].url" [href]="export['vid'].url" target="_blank" style="margin-right: 20px;">Open GS Export</a>
                    <button *ngIf="!export['vid'].loading" type="button" class="btn btn-dark" (click)="exportToGS('vid')">
                        <i class="bi bi-file-earmark-spreadsheet"></i> Export
                    </button>
                    <span *ngIf="export['vid'].loading" class="spinner-border text-dark" role="status" aria-hidden="true"></span>
                </div>
            </div>            
            <div style="width: 73vw !important; overflow-x: scroll;">
                <table class="table table-sm table-condensed table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">URL</th>
                            <th scope="col">Main Angle</th>
                            <th scope="col">Creative Style</th>
                            <th scope="col">Creative Format</th>
                            <th scope="col">Target Market</th>
                            <th scope="col">Market Awareness</th>
                            <th scope="col">Discounts</th>
                            <th scope="col">UGC</th>
                            <th scope="col">Audio Hook</th>
                            <th scope="col">Visual Hook</th>
                            <th scope="col">Text Hook</th>
                            <th scope="col">Creator</th>
                            <th scope="col">Age Group</th>
                            <th scope="col">Gender</th>
                            <th scope="col">Length</th>
                            <th scope="col">Audio Close</th>
                            <th scope="col">Visual Close</th>
                            <th scope="col">Text Close</th>
                            <th scope="col">QA</th>
                            <th scope="col">Review</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="videos.length > 0">
                        <tr *ngFor="let creative of videos">
                            <td><a routerLink="/ad-accounts/creative-assistant/{{ accountId }}/{{ creative.id }}">{{ creative.id }}</a></td>
                            <td><a href="{{ creative.url }}" target="_blank" [ngbTooltip]="creative.url"><img src="{{ creative.thumbnail }}" alt="{{ creative.id }}" style="max-width: 40px; max-height: 40px; border-radius: 3px;"></a></td>                        
                            <td>{{ creative.mainAngle }}</td>                        
                            <td>{{ creative.creativeStyle }}</td>                        
                            <td>{{ creative.creativeFormat }}</td>                        
                            <td>{{ creative.targetMarket }}</td>                        
                            <td>{{ creative.marketAwareness }}</td>                        
                            <td>{{ creative.discounts }}</td>                        
                            <td>{{ creative.ugc }}</td>                        
                            <td>{{ creative.audioHook }}</td>                        
                            <td>{{ creative.visualHook }}</td>                        
                            <td>{{ creative.textHook }}</td>                        
                            <td>{{ creative.creator }}</td>                        
                            <td>{{ creative.ageGroup }}</td>                        
                            <td>{{ creative.gender }}</td>                        
                            <td>{{ creative.length }}</td>                        
                            <td>{{ creative.audioClose }}</td>                        
                            <td>{{ creative.visualClose }}</td>                        
                            <td>{{ creative.textClose }}</td>                                             
                            <td>{{ creative.needsQa ? '❌' : '-' }}</td>                        
                            <td><span [ngbTooltip]="creative.needsExpertReviewReason">{{ creative.needsExpertReview ? '❌' : '-' }}</span></td>                        
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="loadingImages" style="text-align: center;">
                    <span class="spinner-border text-dark" role="status" aria-hidden="true"></span>
                </div>
            </div>

            <div class="row" style="margin-top: 50px;">
                <div class="col">
                    <h1>Carousels<span *ngIf="!loadingCarousels">[{{ carousels.length }}]</span></h1>
                </div>
                <div class="col-auto">
                    <a *ngIf="export['car'].url" [href]="export['car'].url" target="_blank" style="margin-right: 20px;">Open GS Export</a>
                    <button *ngIf="!export['car'].loading" type="button" class="btn btn-dark" (click)="exportToGS('car')">
                        <i class="bi bi-file-earmark-spreadsheet"></i> Export
                    </button>
                    <span *ngIf="export['car'].loading" class="spinner-border text-dark" role="status" aria-hidden="true"></span>
                </div>
            </div>            
             <div style="width: 73vw !important; overflow-x: scroll;">
                <table class="table table-sm table-condensed table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">URL</th>
                            <th scope="col">Main Angle</th>
                            <th scope="col">Creative Style</th>
                            <th scope="col">Creative Format</th>
                            <th scope="col">Target Market</th>
                            <th scope="col">Market Awareness</th>
                            <th scope="col">Discounts</th>
                            <th scope="col">Tiles</th>
                            <th scope="col">QA</th>
                            <th scope="col">Review</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="carousels.length > 0">
                        <tr *ngFor="let creative of carousels">
                            <td><a routerLink="/ad-accounts/creative-assistant/{{ accountId }}/{{ creative.id }}">{{ creative.id }}</a></td>
                            <td><a href="{{ creative.url }}" target="_blank" [ngbTooltip]="creative.url"><img src="assets/images/video.png" alt="{{ creative.id }}" style="max-width: 40px; max-height: 40px; border-radius: 3px;"></a></td>                        
                            <td>{{ creative.mainAngle }}</td>                        
                            <td>{{ creative.creativeStyle }}</td>                        
                            <td>{{ creative.creativeFormat }}</td>                        
                            <td>{{ creative.targetMarket }}</td>                        
                            <td>{{ creative.marketAwareness }}</td>                        
                            <td>{{ creative.discounts }}</td>                        
                            <td>{{ creative.numberOfTiles }}</td>                        
                            <td>{{ creative.needsQa ? '❌' : '-' }}</td>                        
                            <td><span [ngbTooltip]="creative.needsExpertReviewReason">{{ creative.needsExpertReview ? '❌' : '-' }}</span></td>                        
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="loadingImages" style="text-align: center;">
                    <span class="spinner-border text-dark" role="status" aria-hidden="true"></span>
                </div>
            </div>

        </div>    
    </div>
</div>